import { frontendURL } from '../../../helper/URLHelper';
import SubscriptionWrapper from './SubscriptionWrapper.vue';
import Plan from './plan/Plan.vue';
import Usage from './usage/Usage.vue';
import Invoices from '../settings/billing/Invoices.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/subscription'),
      meta: {
        permissions: ['administrator'],
      },
      component: SubscriptionWrapper,
      children: [
        {
          path: 'plan',
          name: 'subscription_plan',
          component: Plan,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'usage',
          name: 'subscription_usage',
          component: Usage,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'invoices',
          name: 'subscription_invoices',
          component: Invoices,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
